import React, { useRef, useState, useEffect } from 'react';
import Player from '@vimeo/player';
import dayjs from 'dayjs';

import { VIDEO_TRACKING } from '../../TrackerFolder/constants/ActionType';
import { onVideoTrack } from '../../TrackerFolder/actions';
import './css/vimeo_player.scss';
import { useMobileOrientation } from 'react-device-detect';

let tracking_data = {
  content_id: '',
  content_type: '',
  start_time: '',
  end_time: '',
  video_duration: '',
  seekbar_change: [],
  progress: [],
  max_view_duration: ''
};

let progressData = {
  step: []
};

let step_counter = 0;
// let player = '';
export default function VimeoPlayer({
  data = '',
  maxViewDuration,
  videoRef,
  tracker,
  customClass
}) {
  // const [currentTime, setCurrentTime] = useState(0.0);
  const currentTime = useRef(0.0);
  const [duration, setDuration] = useState(0.0);
  const videoDetailsParent = useRef();
  const { isLandscape } = useMobileOrientation();
  const [aspectVideoContainerSize, setAspectVideoContainerSize] = useState('0px');
  const [videoUrl, setvideoUrl] = useState('');
  const [videoPlayerControl, setvideoPlayerControl] = useState(true);
  const [videoPlay, setvideoPlay] = useState(true);
  const [progressStep, setProgressStep] = useState(0);
  const [contentType, setContentType] = useState('');
  const [contentId, setContentId] = useState(0);

  const PROGRESS_INTERVAL = 5000;
  const DATA_DESIMAL_POINT = 2;
  const timeFormat = 'YYYY-MM-DD HH:mm:ss';
  const getCurrentTime = () => dayjs(new Date().getTime()).format(timeFormat);
  const setVideoConatinerSize = () => {
    if (videoDetailsParent.current) {
      const videoDivWidth = videoDetailsParent.current ? videoDetailsParent.current.clientWidth : 0;
      const aspectWidth = videoDivWidth / 1.7786;
      setAspectVideoContainerSize(aspectWidth > 0 ? Math.round(aspectWidth) : 0);
      console.log('aspect size is' + aspectWidth);
    }
  };
  useEffect(() => {
    setVideoConatinerSize();
  }, [isLandscape]);
  useEffect(() => {
    if (videoRef) {
      videoRef.current = trackData;
    }
    // let player = '';
    if (data.src) {
      // if (videoRef.current) {
      // }
      setvideoUrl(data.src);
      setContentType(data.content_type);
      setContentId(data.content_id);
      tracking_data.content_id = data.content_id ? data.content_id : 0;
      tracking_data.content_type = data.content_type ? data.content_type : 'not found';

      let player = new Player('handstick', {
        url: data.src ?? '' //https://vimeo.com/event/1668463',
      });

      // alert('type' + typeof player);
      player.ready().then(handleReady).catch((e) => console.log(e));

      player.getVideoTitle().then(function (title) {
        tracking_data.video_title = title;
      })
      .catch((e)=> console.log(e));

      // player
      //   .play()
      //   .then(handlePlay)
      //   .catch(function (error) {
      //     switch (error.name) {
      //       case 'PasswordError':
      //         // the video is password-protected and the viewer needs to enter the
      //         // password first
      //         break;

      //       case 'PrivacyError':
      //         // the video is private
      //         break;

      //       default:
      //         // some other error occurred
      //         break;
      //     }
      //   });

      player
        .getBuffered()
        .then(function (e) {
          console.log('get_buffered' + e);
        })
        .catch(function (error) {
          // an error occurred
        });

      player
        .getCurrentChapter()
        .then(function (chapter) {
          // chapter = a chapter object
        })
        .catch(function (error) {
          // an error occurred
        });

      player
        .getCurrentTime()
        .then(function (seconds) {
          // seconds = the current playback position
        })
        .catch(function (error) {
          // an error occurred
        });

      player
        .getDuration()
        .then(function (duration) {
          // duration = the duration of the video in seconds
        })
        .catch(function (error) {
          // an error occurred
        });

      player
        .getEnded()
        .then(handleVideoEnd)
        .catch(function (error) {
          // an error occurred
        });

      player.on('timeupdate', handleProgress);

      // player.on('progress', handleProgress);

      player.on('play', handlePlay);
      player.on('playing', handleStart);

      player.on('pause', handlePause);

      player.on('bufferstart', handleOnBuffer);

      player.on('bufferend', handleOnBufferEnd);

      player.on('error', handleOnError);

      player.on('loaded', handleLoaded);

      player.on('interactivehotspotclicked', handlePlayerInteraction);

      player.on('interactiveoverlaypanelclicked', handleOverlayInteraction);
      player.on('seeked', handleSeekChange);
    }
    return () => {
      clearAllData();
      // if (player) {
      //   player
      //     .unload()
      //     .then(function () {
      //       // the video was unloaded
      //     })
      //     .catch(function (error) {
      //       // an error occurred
      //     });
      //   player
      //     .destroy()
      //     .then(function () {
      //       // the player was destroyed
      //     })
      //     .catch(function (error) {
      //       // an error occurred
      //     });
      // }
    };
  }, []);

  function trackData() {
    console.log('get tracking called ');
    getTracking();
  }
  const clearAllData = () => {
    tracking_data.content_id = '';
    tracking_data.start_time = '';
    tracking_data.end_time = '';
    tracking_data.video_duration = '';
    tracking_data.seekbar_change = [];
    tracking_data.progress = [];
    tracking_data.max_view_duration = '';
  };

  const getTracking = () => {
    console.log('TRACKING DATA vimeo', tracking_data);
    if (tracking_data?.progress?.length > 0) {
      // tracker.on(VIDEO_TRACKING, onVideoTrack(tracking_data));
    }
  };
  const recordActivity = (action) => {
    let user_action = {};
    user_action['step' + step_counter] = [...progressData.step];
    tracking_data.progress.push(user_action);
    progressData.step = [];
    step_counter += 1;
    // getTracking();
  };

  const handleStart = (e) => {
    // e.preventDefault();
    let tempDuration = e.duration;
    tracking_data.video_duration = tempDuration.toFixed(DATA_DESIMAL_POINT);
    tracking_data.start_time = getCurrentTime();

    let temp_duration = e.seconds;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let startTrackObj = {
      timestamp: getCurrentTime(),
      event: 'video_play_started',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(startTrackObj);
    recordActivity();
  };

  const handlePlayerInteraction = (e) => {
    let startTrackObj = {
      timestamp: getCurrentTime(),
      event: 'interactivehotspotclicked',
      data: e ? JSON.stringify(e) : ''
    };

    progressData.step.push(startTrackObj);
    recordActivity();
  };

  const handleOverlayInteraction = (e) => {
    let startTrackObj = {
      timestamp: getCurrentTime(),
      event: 'interactiveoverlaypanelclicked',
      data: e ? JSON.stringify(e) : ''
    };

    progressData.step.push(startTrackObj);
    recordActivity();
  };
  const handleEnablePIP = () => {
    console.log('onEnablePIP');
  };

  const handleDisablePIP = () => {
    console.log('onDisablePIP');
  };

  const handleSeekMouseDown = (e) => {
    console.log('handleSeekMouseDown');
    // this.setState({ seeking: true })
  };

  const handleSeekChange = (e) => {
    console.log('seeek change.........||||||||||' + currentTime.current);
    let tempFrom = currentTime.current;
    let tempTo = e.seconds;
    let seekTrackObj = {
      timestamp: getCurrentTime(),
      from: tempFrom.toFixed(DATA_DESIMAL_POINT),
      data: e ? JSON.stringify(e) : '',
      to: tempTo.toFixed(DATA_DESIMAL_POINT)
    };
    console.log(tempFrom + 'seeek change.........' + tempTo);
    tracking_data.seekbar_change.push(seekTrackObj);
    console.table(tracking_data.seekbar_change);
    recordActivity();
  };

  const handleProgress = (e) => {
    if (e.seconds) {
      currentTime.current = e.seconds;
    }
    // console.log('time update' + e.seconds);
    if (tracking_data.max_view_duration < e.seconds) {
      let tempCurrentTime = e.seconds;
      tracking_data.max_view_duration = tempCurrentTime.toFixed(DATA_DESIMAL_POINT);
      if (typeof maxViewDuration == 'function') {
        maxViewDuration(tempCurrentTime.toFixed(DATA_DESIMAL_POINT));
      }
    }

    let progressTrackObj = {
      timestamp: getCurrentTime(),
      progressDetails: JSON.stringify(e)
    };

    // progressData.step.push(progressTrackObj);
    // recordActivity();
    // console.log("Progress::\n", JSON.stringify(tracking_data));
  };

  const handleVideoEnd = (e) => {
    tracking_data.end_time = getCurrentTime();
  };

  const handleReady = () => {
    console.log('handle ready');
    let temp_duration = currentTime.current;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let readyTrackObj = {
      timestamp: getCurrentTime(),
      event: 'video_player_ready',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(readyTrackObj);
    recordActivity();
  };

  const handleLoaded = (e) => {
    let temp_duration = currentTime.current;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let readyTrackObj = {
      timestamp: getCurrentTime(),
      event: 'video_loaded_on_player',
      video_id: e ? JSON.stringify(e) : '',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(readyTrackObj);
    recordActivity();
  };

  const handlePlay = (e) => {
    let temp_duration = e.seconds;
    console.log('handle play :' + e.seconds);
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let playTrackObj = {
      timestamp: getCurrentTime(),
      event: 'video_play',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(playTrackObj);
    recordActivity();

    setvideoPlay(true);
  };

  const handlePause = (e) => {
    let temp_duration = e.seconds;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let pauseTrackObj = {
      timestamp: getCurrentTime(),
      event: 'video_pause',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(pauseTrackObj);
    recordActivity();

    setvideoPlay(false);
  };

  const handleOnBuffer = (e) => {
    console.log('buffering ...' + e);
    let temp_duration = currentTime.current;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let bufferTrackObj = {
      timestamp: getCurrentTime(),
      buffer_start: 'Buffering Started',
      current_video_duration: temp_duration ?? ''
    };
    progressData.step.push(bufferTrackObj);
    recordActivity();
  };

  const handleOnBufferEnd = (e) => {
    let temp_duration = currentTime.current;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let bufferTrackObj = {
      timestamp: getCurrentTime(),
      buffer_end: 'Buffering Ended',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(bufferTrackObj);
    recordActivity();
  };

  const handleOnError = (e) => {
    let errorTrackObj = {
      timestamp: getCurrentTime(),
      error: JSON.stringify(e)
    };

    progressData.step.push(errorTrackObj);
    recordActivity();
  };

  return (
    <div
      id="handstick"
      ref={videoDetailsParent}
      className="w-100"
      style={{ height: `${aspectVideoContainerSize}px` }}
    ></div>
  );
}
//data-vimeo-url="https://player.vimeo.com/video/76979871?h=8272103f6e"
